import React from 'react';
import { AlertBanner, Button, SparkIcon, Text } from '@spark';

/**
 * Re-evaluate summary (Figma 199:27399 / 199:27517 / 222:14534): the change
 * banner with "View changes" and the plan card ("Teacher only · sa_benchmark ·
 * 1,200 records" + what runs) with a ghost Edit button.
 */
export default function RevaluateSummaryView({
    bannerText,
    bannerSeverity,
    hasChanges,
    planTitle,
    planBody,
    onEdit,
    onViewChanges,
}) {
    return (
        <div className="revaluate-modal__stack">
            {bannerText && bannerSeverity ? (
                <AlertBanner
                    feedback={bannerSeverity}
                    text={bannerText}
                    contentAlign="center"
                    showCloseButton={false}
                    showButton={hasChanges}
                    buttonType="text"
                    buttonLabel="View changes"
                    onActionClick={onViewChanges}
                />
            ) : hasChanges ? (
                <div className="revaluate-modal__inline-action">
                    <Button variant="link" size="medium" type="button" onClick={onViewChanges}>
                        View changes
                    </Button>
                </div>
            ) : null}
            <div className="revaluate-plan-card">
                <div className="revaluate-plan-card__copy">
                    <Text as="p" variant="base-semibold" color="primary" className="revaluate-plan-card__title">
                        {planTitle}
                    </Text>
                    <Text as="p" variant="detail-regular" color="secondary">
                        {planBody}
                    </Text>
                </div>
                <Button
                    variant="ghost"
                    size="medium"
                    type="button"
                    startIcon={<SparkIcon slug="edit" size="small" />}
                    onClick={onEdit}
                >
                    Edit
                </Button>
            </div>
        </div>
    );
}
